import { render, staticRenderFns } from "./ProductEditorPdfInfo.vue?vue&type=template&id=3b09efc9&"
import script from "./ProductEditorPdfInfo.vue?vue&type=script&lang=js&"
export * from "./ProductEditorPdfInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports